<template>
    <div class="mx-auto">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('thematicArea.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('thematicArea.information') }}</div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-6">
                            <label :for="'legalArea' + _uid" class="font-weight-bold required">{{ $t('thematicArea.legalArea') }}</label>
                            <input type="text"
                                   class="form-control"
                                   readonly
                                   v-model="thematicArea.legalArea" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label :for="'name' + _uid" class="font-weight-bold required">{{ $t('thematicArea.name') }}</label>
                            <input type="text"
                                   class="form-control"
                                   readonly
                                   v-model="thematicArea.name" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('thematicArea.lectors') }}</div>
                </div>
                <div class="card-body" v-for="(lector,index) in thematicArea.lecturers" :key="index">
                    <div class="k-display-flex">
                        <div class="form-group col-md-12 col-lg-8 col-xl-6">
                            <label class="font-weight-bold">{{$t('person.firstName') }}</label>
                            <input type="text" class="form-control" readonly v-model="lector.name">
                        </div>
                        <i class="fas fa-info-circle fa-2x pointer  btn-info k-align-self-center" @click="lectorDetails(lector.id)"></i>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('thematicArea.events') }}</div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('otherFields.otherFields') }}</div>
                </div>
                <div class="card-body">
                    <otherFields :otherFields="thematicArea.otherFields"></otherFields>
                </div>
            </div>

            <div class="mt-3" v-if="thematicArea">
                <AuxiliaryRegisterDetails :entryId="thematicArea.auxRegisterEntityId"></AuxiliaryRegisterDetails>
            </div>
        </div>
    </div>
</template>

<script>
    import OtherFields from '@/components/otherFields/OtherFieldsDetails.vue';
    import { ThematicAreaDetails } from '@/models/models';
    import PageTitle from '@/components/common/PageTitle';
    import AuxiliaryRegisterDetails from '@/components/dynamic/AuxiliaryRegisterDetails'

    export default {
        components: {
            PageTitle,
            OtherFields,
            AuxiliaryRegisterDetails
        },
        props: {
            id: {
                type: Number,
                required: true
            },
            returnUrl: {
                type: String,
                default() {
                    return '';
                }
            }
        },
        data() {
            return {
                thematicArea: new ThematicAreaDetails(),
                loading: false
            }
        },
        methods: {
            backToRegister() {
                this.$router.push(this.returnUrl || '/registers/thematicAreas');
            },
            lectorDetails(lectorId) {
               this.$router.push('/registers/lectors/details/' + lectorId);
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/thematicArea/GetDetails/${this.id}`).then(result => {
                    this.thematicArea = new ThematicAreaDetails(result.data);
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('buttons.load.btnText'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false; });
            }
        },
        mounted() {
            this.loadData();
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }

    .row {
        margin-bottom: 5px;
    }
</style>
